import { strings as errorStrings } from '@components/ErrorComponent/strings';

const strings = {
  labels: {
    header: 'Edit Contact Methods',
    primaryAction: 'Save',
    secondaryAction: 'Cancel',
  },
  successToast: {
    title: 'All Contacts Saved Successfully',
  },
  errorToast: {
    title: 'Some Contacts could not be Saved',
    message: errorStrings.retryMessage,
  },
} as const;

export default strings;
